<div class="scaffold-control-component">
  <label *ngIf="item.translation_key||item.label">{{item.translation_key||item.label| translation|translationFromString | transformText :item?.text_transform}}</label>
  <app-view *ngIf="item.view" [items]="item?.view?.data?.content" [info]="item.view" [data]="{}"></app-view>
  <button nbButton status="primary" class="btn btn-default" (click)="openSearch(info)" *ngIf="item.allow_search" [disabled]="checkDisable()">{{'search'| translation}}</button>
</div>
